import { Injectable } from '@angular/core';
import { PrefixService } from '@zaoblako/web/core/services/prefix/prefix.service';
import { NumberPrefixEnum } from '@zaoblako/shared/common/enums/number-prefix.enum';

@Injectable({ providedIn: 'root' })
export class BrsPrefixService extends PrefixService {
  protected prefix = `${NumberPrefixEnum.BRS_TASK_PREFIX}-`;
}
